import React from "react";
import TeamMember from "./TeamMember";

import NightOwlQueen from "../Resource/images/night_owl_queen_sas.jpeg";
import PaperChaser from "../Resource/images/PaperChaser.jpeg";
import beedub13 from "../Resource/images/beedub13.jpg";
import djinsing from "../Resource/images/djinsing.jpeg";
import MomsSpaghetti from "../Resource/images/MomsSpaghetti.jpeg";

const teamMembers = [
  { name: "PaperChaser", role: "Co-Founder", imageUrl: PaperChaser },
  { name: "MomsSpaghetti", role: "Co-Founder", imageUrl: MomsSpaghetti },
  {
    name: "night_owl_queen_sas",
    role: "Community Manager ",
    imageUrl: NightOwlQueen,
  },
  { name: "beedub13", role: "Mod & Ambassador", imageUrl: beedub13 },
  {
    name: "djinsing",
    role: "Mod, Ambassador and Artist in the making",
    imageUrl: djinsing,
  },
];

const TeamView = () => {

  return (
    <div className="p-8 pt-40">
      <h1 className="text-2xl mb-6 text-center">CORE TEAM</h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 place-items-center">
        {teamMembers.map((member, index) => (
          <div key={index} className="relative w-56">
            <img
              src={member.imageUrl}
              alt={member.name}
              className="w-56 h-56 object-cover rounded-full"
            />
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 mt-2">
              <span className="bg-white text-black px-2 py-1 text-sm rounded">
                {member.name}
              </span>
            </div>
            <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 mb-2 w-56">
              <p className="bg-black text-white px-2 py-1 text-sm rounded text-center">
                {member.role}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TeamView;
